import React from 'react';
import styled from 'styled-components';
import { smMobile } from 'Utils/utilsStyle';
import { IsMobile } from 'Utils/UtilityFunctions';
import SkeletonCustom from './SkeletonCustom';

const Wrapper = styled.div<{ $isMobile?: boolean }>`
  overflow: ${($isMobile) => $isMobile && ' hidden'};

  .feed-highlights-skeleton {
    display: flex;
  }

  .avatar-area {
    margin-right: 12px;
    flex-shrink: 0;

    .avatar-skeleton {
      @media all and (max-width: ${smMobile}) {
        width: 40px !important;
        min-width: 40px !important;
        height: 40px !important;
      }
    }
  }

  .content-area {
    flex: 1;
    min-width: 0;
  }

  .header-area {
    margin-bottom: 8px;
  }

  .footer-area {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 12px;
    flex-wrap: wrap;
  }
`;

type Props = {
  variant?: 'default' | 'withImage' | 'withChips';
  count?: number;
  showHeader?: boolean;
  showFooter?: boolean;
  showTime?: boolean;
};

const FeedHighlightsSkeleton: React.FC<Props> = ({
  count = 1,
  showHeader = true,
  showFooter = true,
}) => {
  const isMobile = IsMobile();
  const renderSkeletonItem = (key: number) => (
    <Wrapper key={key} $isMobile={isMobile}>
      <div className="feed-highlights-skeleton">
        <div className="avatar-area">
          <SkeletonCustom
            className="avatar-skeleton"
            width="48px"
            height="48px"
            diameter="50%"
            margin="0"
          />
        </div>

        <div className="content-area">
          {showHeader && (
            <div className="header-area">
              <SkeletonCustom height="18px" width="100%" diameter="4px" margin="0" />
            </div>
          )}

          {showFooter && (
            <div className="footer-area">
              <SkeletonCustom height="24px" width="60px" diameter="12px" margin="0" />
              <SkeletonCustom height="14px" width="80px" diameter="4px" margin="0" />
              <SkeletonCustom height="14px" width="80px" diameter="4px" margin="0" />
              <SkeletonCustom height="14px" width="80px" diameter="4px" margin="0" />
              <SkeletonCustom height="14px" width="80px" diameter="4px" margin="0" />
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  );

  return <>{Array.from({ length: count }, (_, i) => renderSkeletonItem(i))}</>;
};

export default FeedHighlightsSkeleton;
